// extracted by mini-css-extract-plugin
export default {"circle":"RatingInner_circle__qy8WR","star":"RatingInner_star__Mvg+J","button":"RatingInner_button__nUJi6"};